const openWhatsApp = (whatsapp, e) => {
  e.preventDefault()
  e.stopPropagation()

  // Remover caracteres não numéricos
  const cleanNumber = whatsapp.replace(/\D/g, "")

  // Abrir WhatsApp Web
  window.open(`https://wa.me/55${cleanNumber}`, "_blank")
}

export default openWhatsApp;